module.exports = __webpack_public_path__ + "static/media/logo.ebe30c39.png";